export enum EditorUserFactKeys {
    TOOLBAR_CUSTOM_COLORS = "tiptap/user-defined-custom-colors",
}
